import {
    MultipleChoiceRenderer,
    OpenTextRenderer,
    MultipleSelectRenderer,
    MatrixRenderer,
    HotspotRenderer,
    DragAndDropRenderer,
    SegmentRenderer,
    GraphingRenderer,
    StimulusRendererForSEV,
    StimulusRendererForPreview,
    type QtiQuestionDTO,
    type QtiMultipleChoiceQuestionDTO,
    type QtiOpenTextQuestionDTO,
    type QtiMultipleSelectQuestionDTO,
    type QtiMatrixQuestionDTO,
    type QtiHotspotQuestionDTO,
    type QtiDragAndDropQuestionDTO,
    type QtiStimulusQuestionDTO,
    type QtiSegmentQuestionDTO,
    type QtiGraphingQuestionDTO,
    type UserInteractionMetaDTO,
    type QuestionRendererOptions,
    defaultOptions,
} from './index';

type QuestionRendererProps = {
    question: QtiQuestionDTO;
    handleUpdateUserResponse?: (response: string, didUserInteract: boolean) => void;
    setQuestionLoading?: (loading: boolean) => void;
    stimChildQuestionIds?: number[];
    stimMode: 'preview' | 'sev';
    loadedUserResponse?: string;
    loadedUserInteractionMeta?: UserInteractionMetaDTO;
    options?: QuestionRendererOptions;
};
export function QuestionRenderer({
    question,
    handleUpdateUserResponse,
    setQuestionLoading = () => null,
    stimChildQuestionIds = [],
    stimMode,
    loadedUserResponse,
    loadedUserInteractionMeta,
    options = defaultOptions,
}: QuestionRendererProps) {
    switch (question.meta.questionTypeMasterId) {
        case 1:
            return (
                <MultipleChoiceRenderer
                    question={question as QtiMultipleChoiceQuestionDTO}
                    handleUpdateUserResponse={handleUpdateUserResponse}
                    setQuestionLoading={setQuestionLoading}
                    loadedUserResponse={loadedUserResponse}
                    loadedUserInteractionMeta={loadedUserInteractionMeta}
                    options={options}
                />
            );
        case 2:
            return (
                <OpenTextRenderer
                    question={question as QtiOpenTextQuestionDTO}
                    handleUpdateUserResponse={handleUpdateUserResponse}
                    loadedUserResponse={loadedUserResponse}
                    options={options}
                />
            );
        case 3:
            return (
                <MultipleSelectRenderer
                    question={question as QtiMultipleSelectQuestionDTO}
                    handleUpdateUserResponse={handleUpdateUserResponse}
                    setQuestionLoading={setQuestionLoading}
                    loadedUserResponse={loadedUserResponse}
                    options={options}
                />
            );
        case 4:
            return (
                <MatrixRenderer
                    question={question as QtiMatrixQuestionDTO}
                    handleUpdateUserResponse={handleUpdateUserResponse}
                    loadedUserResponse={loadedUserResponse}
                    options={options}
                />
            );
        case 5:
            return (
                <HotspotRenderer
                    question={question as QtiHotspotQuestionDTO}
                    handleUpdateUserResponse={handleUpdateUserResponse}
                    loadedUserResponse={loadedUserResponse}
                    options={options}
                />
            );
        case 6:
            return (
                <DragAndDropRenderer
                    question={question as QtiDragAndDropQuestionDTO}
                    handleUpdateUserResponse={handleUpdateUserResponse}
                    loadedUserResponse={loadedUserResponse}
                    options={options}
                />
            );
        case 7:
            if (stimMode === 'preview') {
                return (
                    <StimulusRendererForPreview
                        question={question as QtiStimulusQuestionDTO}
                        options={{
                            showScoring: options.showScoring,
                            showAudioButtons: options.showAudioButtons,
                        }}
                    />
                );
            } else {
                return (
                    <StimulusRendererForSEV
                        question={question as QtiStimulusQuestionDTO}
                        handleUpdateUserResponse={handleUpdateUserResponse}
                        childQuestionIds={stimChildQuestionIds}
                        setQuestionLoading={setQuestionLoading}
                        loadedUserResponse={loadedUserResponse}
                        options={options}
                    />
                );
            }
        case 8:
            return (
                <SegmentRenderer question={question as QtiSegmentQuestionDTO} options={options} />
            );
        case 9:
            return (
                <GraphingRenderer
                    question={question as QtiGraphingQuestionDTO}
                    handleUpdateUserResponse={handleUpdateUserResponse}
                    loadedUserResponse={loadedUserResponse}
                    options={options}
                />
            );
    }
}
